export const AddLeadsLiftKeyFormData = [
  {
    name: "leadsLiftToken",
    label: "Token [Example: pit-ca018e29-b564-460b-8bce-8965588da25d]",
    placeholder: "Enter Token",
    rules: [{ required: true, message: "Please input your LeadsLift key!" }],
    type: "password",
  },
  {
    name: "leadsLiftLocationId",
    label: "Location ID [Example: t4GsPWrodvBEEhu7YdSM]",
    placeholder: "Enter Location ID",
    rules: [{ required: true, message: "Please input your Location ID!" }],
    type: "text",
  },
  {
    name: "leadsLiftUserId",
    label: "User ID [Example: zV9YO7cvuuShEuUtQsxZ]",
    placeholder: "Enter User ID",
    rules: [{ required: true, message: "Please input your User ID!" }],
    type: "text",
  },
];
